import * as zod from 'zod';

export const GPUTaskRunnerState = zod.object({
  kind: zod.literal('GPUTaskRunner'),
  host: zod.string().optional(),
  isRunningInference: zod.boolean(),
  isConfiguringInference: zod.boolean(),
  isInitializing: zod.boolean(),
  skillsModels: zod.array(
    zod.object({
      modelFilenames: zod.array(zod.string()),
      modelMetadata: zod
        .object({
          trainingRun: zod.any(),
          botHardware: zod.any(),
        })
        .optional(),
      modelDirectory: zod.string(),
    }),
  ),
  visionModels: zod.array(
    zod.object({
      modelPath: zod.string(),
      // Read from the file by vision-bot; empty from one too old to read it.
      modelType: zod.string().optional(),
      unsupportedReason: zod.string().optional(),
    }),
  ),
  isSkillsBotConnected: zod.boolean(),
  isVisionBotConnected: zod.boolean(),
  isSkillsBotEnabled: zod.boolean(),
  isVisionBotEnabled: zod.boolean(),
  inferenceStatus: zod.enum([
    'normal',
    'completed',
    'failed',
    'error',
    'movementCompletion',
  ]),
  inferenceFailureDetails: zod.string().optional().nullable(),
  cbSoftwareVersion: zod
    .object({
      buildId: zod.string(),
      buildName: zod.string(),
    })
    .optional(),
  gpuTaskRunnerSoftwareVersion: zod
    .object({
      buildId: zod.string(),
      buildName: zod.string(),
    })
    .optional(),
  /**
   * Whether the GPU box itself is reachable, as opposed to whether we could
   * read a version off it. `undefined` means no answer yet: either the first
   * status poll is still in flight, or the registry lookup failed and stays
   * failing. Both are distinct from `false`, a peer we looked for and did not
   * find. Treat it as an open-ended unknown, not a bounded startup window.
   */
  isGpuPeerConnected: zod.boolean().optional(),
  versionMismatch: zod.boolean().optional(),
  complianceFlagsMismatch: zod.boolean().optional(),
  /**
   * A remote runner's own `roboflowUpload` flag, which decides whether its
   * inference container uploads. Unset for a local runner.
   */
  peerRoboflowUpload: zod.boolean().optional(),
});

export type GPUTaskRunnerState = zod.infer<typeof GPUTaskRunnerState>;
